import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { BaseHttpService } from './base-http.service';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from './config.service';
import { AuthenticationService } from './authentication.service';
import { EventsServiceDateRange } from './events.service';

@Injectable()

export class SentimentAnalysisService extends BaseHttpService {
  // private resource = 'survale-analysis';

  constructor(
    public http: HttpClient,
    public configService: ConfigService,
    public authenticationService: AuthenticationService
  ) {
    super(http);
  }

  // getAnalysisList(surveyIds: string) {
  //   const params: any = {
  //     surveyIds
  //   };
  //   return this.get('sentiment-analysis', undefined, params);
  // }

  // surveyIds, q.npsOnly === 'yes', q.sort === 'asc', q.limit, q.offset]
  getSentimentAnalysis(limit: number, offset: number,
    dateRange: EventsServiceDateRange, surveyIds: string, filters: any, searchTerm: string) {
    const params: any = {
      dateRange: encodeURIComponent(JSON.stringify(dateRange)),
      filters: encodeURIComponent(JSON.stringify(filters)),
      searchTerm: encodeURIComponent(searchTerm),
      surveyIds, limit, offset
    };
    return this.get('sentiment-analysis', undefined, params);
  }

  getSentimentAnalysisPy(limit: number, offset: number,
    dateRange: EventsServiceDateRange, surveyIds: string, filters: any, searchTerm: string) {
    const params: any = {
      dateRange: encodeURIComponent(JSON.stringify(dateRange)),
      filters: encodeURIComponent(JSON.stringify(filters)),
      searchTerm: encodeURIComponent(searchTerm),
      surveyIds, limit, offset
    };
    return this.get('ai-sentiment-analysis', undefined, params);
  }

  getChartData(dateRange: EventsServiceDateRange, surveyIds: string, filters: any, chartType: string) {
    const params: any = {
      dateRange: encodeURIComponent(JSON.stringify(dateRange)),
      filters: encodeURIComponent(JSON.stringify(filters)),
      surveyIds,
      chartType
    };
    return this.get('ai-analysis-chart-data', undefined, params);
  }

  /**
   * Record AI feedback (thumbs up/down) for a comment
   * @param documentId - The Elasticsearch document ID of the answer/comment
   * @param feature - The AI feature being rated (e.g., 'legal', 'sentiment', 'classification', 'overall')
   * @param reaction - The user's reaction ('ThumbsUp' or 'ThumbsDown')
   * @param comment - Optional comment explaining the feedback
   */
  recordAIFeedback(documentId: string, feature: string, reaction: 'ThumbsUp' | 'ThumbsDown', comment?: string) {
    const body: any = {
      feature,
      reaction
    };
    if (comment) {
      body.comment = comment;
    }
    return this.post(`ai-feedback/${documentId}`, body);
  }

  /**
   * Get AI feedback for a single document
   * @param documentId - The Elasticsearch document ID of the answer/comment
   * @param feature - Optional filter by AI feature type
   */
  getAIFeedback(documentId: string, feature?: string) {
    const params: any = {};
    if (feature) {
      params.feature = feature;
    }
    return this.get(`ai-feedback/${documentId}`, undefined, params);
  }

  /**
   * List all AI feedback across all documents
   * @param options - Query options for filtering and pagination
   * @param options.feature - Optional filter by AI feature type (e.g., 'legal', 'sentiment')
   * @param options.reaction - Optional filter by reaction type ('ThumbsUp', 'ThumbsDown')
   * @param options.size - Page size (default: 50)
   * @param options.from - Pagination offset (default: 0)
   */
  listAIFeedback(options: {
    feature?: string;
    reaction?: 'ThumbsUp' | 'ThumbsDown';
    size?: number;
    from?: number;
  } = {}) {
    const params: any = {};
    if (options.feature) {
      params.feature = options.feature;
    }
    if (options.reaction) {
      params.reaction = options.reaction;
    }
    if (options.size !== undefined) {
      params.size = options.size;
    }
    if (options.from !== undefined) {
      params.from = options.from;
    }
    return this.get('ai-feedback-list', undefined, params);
  }

  /**
   * Record user feedback on RAG (Retrieval-Augmented Generation) responses
   * @param question - The question asked by the user
   * @param answer - The AI-generated answer
   * @param reaction - The user's reaction ('ThumbsUp' or 'ThumbsDown')
   * @param userComment - Optional comment explaining the feedback (typically for thumbs down)
   */
  recordRAGFeedback(question: string, answer: string, reaction: 'ThumbsUp' | 'ThumbsDown', userComment?: string) {
    const body: any = {
      question,
      answer,
      reaction
    };
    if (userComment) {
      body.userComment = userComment;
    }
    return this.post('rag-feedback', body);
  }

}
